import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t", ";\n\tbackground: rgba(0, 0, 0, 0.8);\n\tborder: 1px solid rgba(255, 255, 255, 0.5);\n\tborder-radius: 3px;\n\tcolor: ", ";\n\tdisplay: inline-flex;\n\tfont-family: ", ";\n\tfont-size: ", ";\n\tpadding: 2px 4px;\n\tpointer-events: none;\n\tvertical-align: middle;\n\twhite-space: nowrap;\n\n\t& + & {\n\t\tmargin-left: ", ";\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { styled, ui } from '@wp-g2/styles';
export var DebuggerView = styled.div(_templateObject(), ui.zIndex('Debugger', 99), ui.color.white, ui.get('fontFamilyMono'), ui.get('fontSizeXSmall'), ui.space(0.5));